module.exports = __webpack_public_path__ + "static/img/08.c3b5a9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/08.jpg
// module id = 9yyo
// module chunks = 1